// extracted by mini-css-extract-plugin
export default {"cardTabContainer":"CardTab_cardTabContainer__+Q0GT"};